import { useEffect } from 'react';
import apiRequest from 'v1/utils/api-request';

// Makes a request to the API to prevent a cold start if no instances are running
export default function usePreventColdStart() {
  useEffect(() => {
    try {
      apiRequest('wakeup');
    } catch (error) {}
  }, []);
}
